import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import Plot from "react-plotly.js";

import { Card, CardHeader, Row, Col } from "reactstrap";
import { MoreVert } from "@material-ui/icons";

function MetricsGraph(props) {
  const [mitigateChk, setMitigateChk] = useState(true);
  const data = [];

  var temp = {};

  return (
    <Col xl={props.type === "default" ? "12" : "6"} className="mt-5">
      <Card
        style={{
          border: "1px solid #EAECF0",
          borderRadius: "12px",
          boxShadow: "0px 1px 2px 0px #1018280D",
          backgroundColor: "#fff",
        }}
      >
      <CardHeader style={{backgroundColor:"#FFF", borderTopLeftRadius:"12px",borderTopRightRadius:"12px"}} >
      <Row className="align-items-center">
            <div className="col" style={{ display: "inline-flex" }}>
              {/* <h4 className="mb-0" title={des[props.name]} style={{ cursor: "help", textTransform: "capitalize" }}> <b title={des[props.name]} >{props.name}</b></h4> */}
              <span
                style={{
                  marginLeft: "auto",
                  float: "right",
                  cursor: "help",
                  color: "#101828",
                }}
              >
                <i
                  title={props.data.discription}
                  style={{ cursor: "help", "font-size": "20px", color: "#101828" }}
                  
                  aria-hidden="true"
                ><MoreVert/></i>
              </span>
            </div>
          </Row>
        </CardHeader>
        <br />
        <br />
        <Plot
          style={{
            marginTop: "-2.5%",
            borderRadius: "25px",
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
          data={props.data.values}
          layout={props.data.layout}
          config={{
            showLink: false,
            displayModeBar: false,
            responsive: true,
          }}
        />
        <br />
      </Card>
    </Col>
  );
}

export default MetricsGraph;
